module.exports = __webpack_public_path__ + "img/redpocket.230b002a.png";